// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import JS
import menuOpen from "./menuOpen";
import lightbox from "./lightbox";
// import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
// infiniteScroll();
